import { Component, EventEmitter, Output, ViewChild, input, ChangeDetectionStrategy } from '@angular/core';
import { TinyHelpers } from '@coin/shared/core/util-helpers';
import { Workflow } from '@coin/shared/core/util-models';
import { V2DropdownComponent } from '@coin/shared/core/ui-storybook';

@Component({
  selector: 'admin-table-dropdown-edit-field',
  templateUrl: './table-dropdown-edit-field.component.html',
  styleUrls: ['./table-dropdown-edit-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class TableDropdownEditFieldComponent {
  @ViewChild(V2DropdownComponent) dropdown: V2DropdownComponent;

  readonly data = input<Record<string, string | number>>({});
  readonly model = input('');
  readonly disabled = input<boolean>(undefined);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  readonly items = input<any[]>(undefined);
  readonly isWorkflow = input(false);
  readonly isDiplayFn = input(false);

  readonly canDelete = input(true);

  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() change = new EventEmitter<void>();

  public isEditable = false;

  public get valueAsText(): string {
    return this.isWorkflow()
      ? TinyHelpers.pascalcaseToText(this.items()?.find(item => item.id === this.data()[this.model()])?.type)
      : this.isDiplayFn()
        ? this.displayFn(this.data()[this.model()] as string)
        : (this.data()[this.model()] as string);
  }

  public onOpenedChange(opened: boolean): void {
    if (!opened) {
      this.isEditable = false;
    }
  }

  public getModel(): unknown {
    return this.isWorkflow()
      ? this.items()?.find(item => item.id === this.data()[this.model()])
      : this.data()[this.model()];
  }

  public onSelect(value): void {
    this.data()[this.model()] = this.isWorkflow() ? value.id : value;
    this.change.emit();
    this.isEditable = false;
  }

  public clear(): void {
    this.data()[this.model()] = null;
    this.change.emit();
  }

  public edit(): void {
    this.isEditable = true;
    setTimeout(() => this.dropdown?.openDropdown());
  }

  public getDisplayFn(): (s: string | Workflow) => string {
    return this.isDiplayFn() ? this.displayFn : this.isWorkflow() ? this.workflowDisplayFn : null;
  }

  public workflowDisplayFn(item: Workflow): string {
    return TinyHelpers.pascalcaseToText(item.type);
  }

  public displayFn(item: string): string {
    return TinyHelpers.pascalcaseToText(item);
  }
}
